import { Link } from 'react-router-dom';
import PolicyLayout from './PolicyLayout';
import { POLICY_UPDATED, SITE_DOMAIN, SUPPORT_EMAIL } from '../constants/site';

export default function CookiePolicy() {
  return (
    <PolicyLayout
      title="Cookie Policy"
      updated={POLICY_UPDATED}
      intro={`How ${SITE_DOMAIN} uses cookies and similar storage, and how to turn them off.`}
    >
      <h2>What cookies are</h2>
      <p>
        Cookies are small text files a site stores in your browser. They let the site remember
        things between page loads, such as whether you have already submitted a form.
      </p>

      <h2>Strictly necessary</h2>
      <p>
        These keep the site working. They remember your session while you complete a request
        and protect the form against automated abuse. They cannot be switched off from within
        the site because nothing would function without them.
      </p>

      <h2>Analytics</h2>
      <p>
        We record aggregate page views so we know which help topics people actually read.
        These figures are not linked to your name or email address, and we do not build
        advertising profiles from them.
      </p>

      <h2>What we do not use</h2>
      <p>
        We do not run third party advertising pixels, cross-site tracking or retargeting
        cookies on this domain.
      </p>

      <h2>Turning cookies off</h2>
      <p>
        Every major browser lets you block or delete cookies from its privacy settings. The
        pages on this site remain readable with cookies blocked, though form submission may
        need to be retried.
      </p>

      <h2>Questions</h2>
      <p>
        Email <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>, or read our{' '}
        <Link to="/privacy-policy">privacy policy</Link> for what happens to the data itself.
      </p>
    </PolicyLayout>
  );
}
